'use strict';

var $iscapPhoneEnable = $('#isEnableCapPhone');

if ($iscapPhoneEnable.length > 0 && $iscapPhoneEnable.val() === 'true') {
    var formUtils = require('./formUtils');
    formUtils.initCapPhoneByForms();
}
